import { render, staticRenderFns } from "./DealsAvailability.vue?vue&type=template&id=17d668e6&scoped=true&"
import script from "./DealsAvailability.vue?vue&type=script&lang=ts&"
export * from "./DealsAvailability.vue?vue&type=script&lang=ts&"
import style0 from "./DealsAvailability.vue?vue&type=style&index=0&id=17d668e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d668e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d668e6')) {
      api.createRecord('17d668e6', component.options)
    } else {
      api.reload('17d668e6', component.options)
    }
    module.hot.accept("./DealsAvailability.vue?vue&type=template&id=17d668e6&scoped=true&", function () {
      api.rerender('17d668e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/DealsAvailability.vue"
export default component.exports